export default __webpack_public_path__ + "static/logo-institute-47ece86a1560b54cce31a119a04eec99.svg";